import { IconProps } from './Close';

const Icon = ({ size, backgroundColor, color }: IconProps) => {
  return (
    <svg
      id="Upload_icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size || '18'}
      height={size || '18'}
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="사각형_2131"
            data-name="사각형 2131"
            width={size || '18'}
            height={size || '18'}
            transform="translate(544 1086)"
            fill={backgroundColor || '#fff'}
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <rect id="사각형_2136" data-name="사각형 2136" width="48" height="48" fill="none" />
      <g
        id="마스크_그룹_188"
        data-name="마스크 그룹 188"
        transform="translate(-543 -1085)"
        clipPath="url(#clip-path)"
      >
        <g id="Layer_2" data-name="Layer 2" transform="translate(544 1086.521)">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="패스_901"
              data-name="패스 901"
              d="M35.547,20.042V14.2l-2.091-2.091L23.44,2.091,21.349,0H3.136A3.136,3.136,0,0,0,0,3.136V36.592a3.136,3.136,0,0,0,3.136,3.136H23.262A12.546,12.546,0,1,0,35.547,20.042ZM21.955,3.576,31.971,13.591H21.955ZM3.136,37.638a1.045,1.045,0,0,1-1.045-1.045V3.136A1.045,1.045,0,0,1,3.136,2.091H19.864V15.682H33.456v4.182A12.546,12.546,0,0,0,22.039,37.638Zm30.319,5.227a10.454,10.454,0,0,1-7.464-3.135,10.717,10.717,0,0,1-1.59-2.092,10.455,10.455,0,1,1,9.054,5.227Z"
              fill={color || '#404040'}
            />
            <rect
              id="사각형_2133"
              data-name="사각형 2133"
              width="2.091"
              height="12.546"
              rx="1.045"
              transform="translate(32.41 26.137)"
              fill={color || '#404040'}
            />
            <rect
              id="사각형_2134"
              data-name="사각형 2134"
              width="12.546"
              height="2.091"
              rx="1.045"
              transform="translate(27.183 31.365)"
              fill={color || '#404040'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
